import types from "../../actions/clientsActions/types";
import { FETCH_STATUS } from "../../../constants/index";

export const clientDetail = (
    state = {
        data: {},
        status: FETCH_STATUS.NOT_LOADED,
        error: "",
    },
    action
) => {
    const { payload: { error, data } = {} } = action;
    switch (action.type) {
        case types.FETCH_CLIENT_BY_ID_REQUEST:
            return {
                ...state,
                status: FETCH_STATUS.LOADING,
                error: null,
            };
        case types.FETCH_CLIENT_BY_ID_SUCCESS:
            return {
                ...state,
                data: data,
                status: FETCH_STATUS.LOADED,
            };
        case types.FETCH_CLIENT_BY_ID_FAILURE:
            return {
                ...state,
                status: FETCH_STATUS.FAILED,
                error,
            };

        default:
            return state;
    }
};

export default clientDetail;